<div class="qpx-splash-card">
    <qpx-logo class="qpx-logo" variant="black" size="md" />
    @if (!isError()) {
        <div class="qpx-splash-loading-state">
            <div class="content">
                <h3 class="title">Getting things ready</h3>

                <div class="status" aria-hidden="true">
                    <span>Inspecting building records...</span>
                    <span>Preparing property data...</span>
                    <span>Checking compliance details...</span>
                    <span>Loading maintenance history...</span>
                    <span>Reviewing site documents...</span>
                    <span>Organising building insights...</span>
                    <span>Fetching asset information...</span>
                    <span>Preparing inspection notes...</span>
                </div>
            </div>

            <div
                class="progress"
                role="progressbar"
                aria-label="Loading"
                aria-busy="true"
            ></div>
        </div>
    } @else {
        <div class="qpx-splash-error-state" role="alert" aria-live="assertive">
            <div class="visual">
                <img
                    class="image"
                    [ngSrc]="errorImage.src"
                    [attr.srcset]="errorImage.srcset ?? null"
                    [alt]="errorImage.alt"
                    [height]="errorImage.height"
                    [width]="errorImage.width"
                    [placeholder]="errorImage.placeholder ?? false"
                    loading="lazy"
                    disableOptimizedSrcset
                />
            </div>

            <div class="content">
                <h3 class="title">Something went wrong</h3>

                <p class="description">
                    Please refresh the page or try again shortly.
                </p>
            </div>
        </div>
    }
</div>
